const ACTIVITY_EVENT = "t2b-user-activity";

let lastActivityAt = Date.now();
let isDispatchingActivity = false;

export function markUserActivity() {
  lastActivityAt = Date.now();
  if (typeof window === "undefined" || isDispatchingActivity) return;

  // Listeners of this event must not call markUserActivity again, or it recurses.
  isDispatchingActivity = true;
  try {
    window.dispatchEvent(new CustomEvent(ACTIVITY_EVENT));
  } finally {
    isDispatchingActivity = false;
  }
}

export function getLastActivityAt() {
  return lastActivityAt;
}

export function subscribeUserActivity(onActivity: () => void) {
  if (typeof window === "undefined") {
    return () => undefined;
  }

  const handler = () => onActivity();
  window.addEventListener(ACTIVITY_EVENT, handler);
  return () => window.removeEventListener(ACTIVITY_EVENT, handler);
}
